var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.$sketchy_nombres[_vm.subset][_vm.n][_vm.style],{tag:"component",staticClass:"baseNombre",class:{'troisChiffres': _vm.troisChiffres}})}
var staticRenderFns = []

export { render, staticRenderFns }